// components/Layout/Layout.js
import React from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import './Layout.css';

const Layout = ({ children }) => {
  const location = useLocation();
  
  // Check if current route is a store page
  const isStorePage = location.pathname.startsWith('/') && 
                     location.pathname !== '/' && 
                     location.pathname !== '/login' && 
                     location.pathname !== '/register' &&
                     !location.pathname.startsWith('/admin') &&
                     !location.pathname.startsWith('/owner');

  return (
    <div className="layout">
      {!isStorePage && <Navbar />}
      <main className={isStorePage ? 'store-page-main' : 'main-content'}>
        {children}
      </main>
    </div>
  );
};

export default Layout;